/**
 * 「공중계정 연동 관리」 표의 운영자 전용 「위임 단계」 열 (SPEC-CHINA-WECHAT-OPEN-PLATFORM-001 F6)
 * 운영자가 아니면 열 정의 자체를 넣지 않는다 — 숨김 처리가 아니라 부재.
 */
export const STAGE_COLUMN_KEY = 'wxStage';

export function buildVisibleColumns(columns, showStage, title) {
    if (!showStage) return columns;
    const idx = columns.findIndex((c) => c.key === 'action');
    const cols = [...columns];
    cols.splice(idx < 0 ? cols.length : idx, 0, { title, key: STAGE_COLUMN_KEY, width: 170 });
    return cols;
}
